import type {HTMLAttributes, ReactNode} from 'react';

export interface AnimatedBorderElementProps extends HTMLAttributes<HTMLElement>{
  children?: ReactNode;
  elementType?: AnimatedBorderElementType;
  animationDurationMs?: number;
  animationCount?: number;
  radius?: number;
  width?: number;
}

export enum AnimatedBorderElementType {
  DIV = 'div',
  LI = 'li'
}